import { NetworkStatus, useQuery } from "@apollo/client";
import { getUnixTime } from "date-fns/esm";
import { useState } from "react";
import { useLocation } from "react-router-dom";

import DocumentationIconButton from "components/DocumentationIconButton";
import PageLoading from "components/loading/PageLoading";
import DesktopView from "components/Mobile/DesktopView";
import PageWrapper from "components/PageWrapper";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";

import { GET_ACCOUNT_RUNS } from "./gql";
import { getDefaultDateRange } from "./helpers";
import { AccountRunsData } from "./types";
import Runs from "./Wrapper";

const RunsWrapper = () => {
  const [dateRange, setDateRange] = useState(getDefaultDateRange);
  const { search } = useLocation();
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Runs · ${accountName}`);

  const { error, loading, data, refetch, networkStatus } = useQuery<AccountRunsData>(
    GET_ACCOUNT_RUNS,
    {
      variables: {
        start: `${getUnixTime(dateRange.startDate)}`,
        end: `${getUnixTime(dateRange.endDate)}`,
      },
    }
  );

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && networkStatus === NetworkStatus.loading && !data?.stacks) {
    return <PageLoading />;
  }

  return (
    <>
      <ViewHeader>
        <ViewHeaderTitle>Runs</ViewHeaderTitle>
        <DesktopView>
          <ViewHeaderWrapper direction="row">
            <DocumentationIconButton
              href={getDocsUrl("/concepts/run")}
              tooltipText="Go to runs documentation"
            />
          </ViewHeaderWrapper>
        </DesktopView>
      </ViewHeader>

      <PageWrapper>
        <Runs
          data={data || {}}
          search={search}
          dateRange={dateRange}
          setDateRange={setDateRange}
          refetchData={refetch}
          isAccountWide
        />
      </PageWrapper>
    </>
  );
};

export default RunsWrapper;
